import store from 'react/redux/store/store';
import { privateChatMessageHolder } from 'components/PrivateChatMessageHolder';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { isPhoneWidth } from 'react/dock/phoneWidth';
import { openDockDirectMessage } from 'react/dock/chat/openDockChat';

/**
 * Message on a profile card or in the bell: opens the conversation on this
 * page, in place on the netplay page and in the dock's chat sheet elsewhere.
 * Returns false on a phone, which has no sheet: the caller goes to the
 * netplay page instead.
 */
export default function openDirectMessageHere(player) {
	if(isNetplayPageActive()) {
		privateChatMessageHolder.openPrivateChat(player);
		return true;
	}
	if(isPhoneWidth()) {
		return false;
	}
	store.dispatch(openDockDirectMessage(player));
	return true;
}
